<template>
  <div class="app-shell home-page info-page">
    <div class="app-shell__main">
      <AppHeader />

      <main class="info-main">
        <section class="info-hero info-hero--tutorial">
          <div class="info-badge">Tutorial</div>
          <h1 class="info-title">使用教程</h1>
          <p class="info-description">围绕网站最常见的链接去水印流程，把上手路径压缩成三步，第一次使用也能很快完成。</p>
          <div class="info-summary">
            <article v-for="item in summary" :key="item.title" class="info-summary-card">
              <strong>{{ item.title }}</strong>
              <span>{{ item.text }}</span>
            </article>
          </div>
        </section>

        <section class="info-panel">
          <div class="info-section-head">
            <h2 class="section-title">详细步骤</h2>
            <p>当前网页端最常见的使用方式，就是复制平台分享链接后进入链接去水印页面处理。</p>
          </div>

          <div class="tutorial-list">
            <article v-for="step in steps" :key="step.id" class="tutorial-card">
              <div class="tutorial-card__side">
                <div class="tutorial-card__no">{{ step.id }}</div>
                <div class="tutorial-card__tag">{{ step.tag }}</div>
              </div>
              <div class="tutorial-card__body">
                <h3 class="tutorial-card__title">{{ step.title }}</h3>
                <p class="tutorial-card__description">{{ step.description }}</p>
                <ul class="info-points">
                  <li v-for="point in step.points" :key="point">{{ point }}</li>
                </ul>
                <div class="tutorial-figure">
                  <div class="tutorial-figure__note">{{ step.note }}</div>
                  <figure class="tutorial-figure__frame">
                    <img :src="step.image" :alt="step.caption" :class="['tutorial-figure__image', step.figureClass]">
                    <figcaption>{{ step.caption }}</figcaption>
                  </figure>
                </div>
              </div>
            </article>
          </div>

          <div class="info-note-panel">
            <h3>使用小提示</h3>
            <ul class="info-points">
              <li>如果链接复制后没有自动粘贴，可以先手动点击输入框再粘贴。</li>
              <li>若解析后保存失败，可以复制结果链接到浏览器中再尝试下载。</li>
              <li>不同平台的分享文案样式可能不同，但只要复制成功，通常都可以识别。</li>
            </ul>
          </div>
        </section>
      </main>
    </div>

    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import tutorialStep1 from '@/assets/tutorial-step-1.jpg'
import tutorialStep2 from '@/assets/tutorial-step-2.jpg'
import tutorialStep4 from '@/assets/tutorial-step-4.png'

export default {
  name: 'TutorialPage',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      summary: [
        { title: '使用前准备', text: '确保已经打开目标短视频 App，并找到想要处理的内容。' },
        { title: '核心操作', text: '分享视频，复制链接，再回到网站粘贴解析。' },
        { title: '解析结果', text: '支持查看视频、图片、音乐和文案，并按需下载保存。' }
      ],
      steps: [
        {
          id: '1',
          tag: '找到分享入口',
          title: '打开短视频 App，点击分享',
          description: '先在目标平台中找到你想保存的视频或图文内容，然后点击分享按钮，准备获取可解析的链接。',
          points: ['建议先完整加载视频页面，再进行分享。', '如果是图文内容，也可以先进入详情页后再分享。'],
          note: '重点：红框位置就是需要点击的“分享”按钮。',
          caption: '步骤 1：点击目标视频右下角的分享入口',
          image: tutorialStep1,
          figureClass: 'is-mobile'
        },
        {
          id: '2',
          tag: '复制视频链接',
          title: '在分享面板中点击“复制链接”',
          description: '分享面板底部通常会显示“复制链接”。如果当前没有看到，可以左右滑动工具栏继续寻找。',
          points: ['部分平台会显示为“复制口令”或“复制文案”，通常也同样可用。', '复制成功后，可直接切回浏览器打开本站。'],
          note: '重点：红圈标记的是“复制链接”区域；如果没看到，请左右滑动底部功能栏继续寻找。',
          caption: '步骤 2：在分享面板中点击“复制链接”',
          image: tutorialStep2,
          figureClass: 'is-mobile'
        },
        {
          id: '3',
          tag: '回到网站解析',
          title: '进入链接去水印页面，粘贴内容并一键解析',
          description: '打开网站后进入链接去水印，确认链接已经填入输入框，再点击“一键解析”即可获取无水印结果。',
          points: ['如果输入框没有内容，先确认复制是否成功。', '解析完成后，可按需下载视频、封面或音频结果。'],
          note: '重点：标记了解析页面的核心操作区域，按顺序完成“粘贴”和“一键解析”即可。',
          caption: '步骤 3：粘贴链接并点击“一键解析”',
          image: tutorialStep4,
          figureClass: 'is-web'
        }
      ]
    }
  }
}
</script>
